var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCompare = function SvgCompare(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "M15.438 15.25h-4.814V7.19a2.19 2.19 0 0 0 1.187-1.298l3.61-1.206a.437.437 0 0 0 .275-.553l-.277-.83a.437.437 0 0 0-.554-.276L11.64 4.103a2.18 2.18 0 0 0-3.437-.462c-.41.41-.64.967-.64 1.547q.004.138.027.273L4.08 6.64a.44.44 0 0 0-.276.553l.277.83a.44.44 0 0 0 .554.276l3.886-1.302a2 2 0 0 0 .355.195v9.371a.44.44 0 0 0 .438.438h6.124a.44.44 0 0 0 .438-.438v-.874a.44.44 0 0 0-.438-.438m3.062-3.938c0-.443.037-.24-2.325-4.963a1.313 1.313 0 0 0-2.348 0c-2.383 4.765-2.327 4.535-2.327 4.963 0 1.208 1.567 2.188 3.5 2.188s3.5-.98 3.5-2.188m-5.473-.438L15 6.938l1.969 3.938zM5.674 9.85a1.313 1.313 0 0 0-2.349 0C.945 14.614 1 14.384 1 14.812 1 16.02 2.567 17 4.5 17S8 16.02 8 14.812c0-.441.036-.238-2.326-4.962m-3.147 4.526L4.5 10.438l1.973 3.938z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCompare);
export default ForwardRef;